import { View, StyleSheet, Platform } from "react-native";
import { useTheme } from "@/hooks/useTheme";
import useAuth from "@/hooks/useAuth";
import Profile from "@/components/Header/ProfileButton";
import * as Device from "expo-device";
import { HeaderTooltipButton } from "./HeaderTooltipButton";
import { QuickActionsButton } from "./QuickActionsButton";
import { NotificationsButton } from "./NotificationsButton";
import { useEntityTablePageConfig } from "@/providers/EntityTablePageProvider";
import { ActionZone } from "@/components/ActionBar/ActionZone";
import { HEADER } from "@/components/Header/constants";

export function HeaderRight() {
  const { toggleTheme } = useTheme();
  const { session } = useAuth();
  const mobileLayout = Platform.OS !== "web" || Device.deviceType === Device.DeviceType.PHONE;
  const etpConfig = useEntityTablePageConfig();

  return (
    <View style={styles.headerRight}>
      {/* EntityTablePage right-side controls (driven by context) */}
      {etpConfig && <ActionZone onRefresh={etpConfig.onRefresh} dirty={etpConfig.dirty} actions={etpConfig.actions} />}

      {session && <NotificationsButton />}
      {session && <QuickActionsButton />}
      <HeaderTooltipButton
        icon="theme-light-dark"
        tooltip="Toggle Theme"
        onPress={() => toggleTheme()}
        style={{ height: HEADER.ICON_SIZE, width: HEADER.ICON_SIZE }}
      />
      {session && !mobileLayout && <Profile />}
    </View>
  );
}

const styles = StyleSheet.create({
  headerRight: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 8,
    paddingRight: 8,
  },
});
